import {gsap} from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { SplitText } from 'gsap/SplitText';
import $ from "jquery";
import { isMobile } from 'detect-touch-device';

let splitProfilHeadline;
let splitServiceHeadline;
let splitWorkHeadline;
let smoother;

function updateHeadline(triggerClass, headlineSelector) {
  let splitHeadline = new SplitText(headlineSelector, {
    type: "lines",
    linesClass: "split-line"
  });

  $(headlineSelector + ' .split-line').wrap('<div class="line-wrapper">');

  let animation = gsap.timeline({
    scrollTrigger: {
      trigger: triggerClass,
      start: 'top 95%',
      end: 'bottom 60%',
      markers: false,
      scrub: true,
      toggleActions: "play none none reset"
    }
  });

  animation.fromTo(splitHeadline.lines,
    { top: '60px' },
    { duration: 1.5, ease: "power3.out", top: 0, stagger: { from: "start", each: 0.2 } }
  );
}

class CustomAnimation {

  init() {
    gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother);

    // ScrollSmoother only on Desktop
    if (!isMobile) {

      ScrollTrigger.normalizeScroll(true)
      smoother = ScrollSmoother.create({
        wrapper: '.page',
        content: ".scroll",
        smooth: 1.6, // how long (in seconds) it takes to "catch up" to the native scroll position
        effects: true, // looks for data-speed and data-lag attributes on elements
        smoothTouch: 0, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)#
        normalizeScroll: true,
        speed: 1
      });
   }

    // deeplink
    let hash = window.location.hash;
    if (hash === '') {
      hash = '#header';
    }
    if (!isMobile) {
      gsap.to(smoother, {
        scrollTop: smoother.offset(hash, "top top"),
        duration: 0.1,
        ease: "power4.out",
      });
    }
    else {
      gsap.to(window, {
        duration: 0,
        ease: "power4.out",
        scrollTo:{
          y: hash,
          autoKill: false}
      })
   }

    // logo color
    const sections = gsap.utils.toArray(".section");
    sections.forEach((section) => {
      ScrollTrigger.create({
        trigger: section,
        start: "top 60",
        end: "bottom 60",
        markers: false,
        onEnter: () => changeLogoColor(section.dataset.logocolor) ,
        onEnterBack: () => changeLogoColor(section.dataset.logocolor)
      });
    });

    function changeLogoColor( color ) {
      if(color === "white") {
        $('.top_logo').removeClass('logo_is_black');
        $('.burger_menu').removeClass('burger_menu_is_black');
      }
      else
      {
        $('.top_logo').addClass('logo_is_black');
        $('.burger_menu').addClass('burger_menu_is_black');
      }
    }
  }

  initMagneticButtons = () => {
    // Magnetic Buttons
    // Found via: https://codepen.io/tdesero/pen/RmoxQg
    let magnets = document.querySelectorAll('.magnetic');

    // mobil
    if(window.innerWidth > 540){

      // Mouse Reset
      magnets.forEach( (magnet) => {
        magnet.addEventListener('mousemove', moveMagnet );
        magnet.addEventListener('mouseleave', function(event) {
          gsap.to( event.currentTarget, 1.5, {
            x: 0,
            y: 0,
            ease: "elastic.out(1,0.3)"
          });
          if($(this).find(".btn-text").length) {
            gsap.to($(this).find(".btn-text"), 1.5, {
              x: 0,
              y: 0,
              ease: "elastic.out(1,0.3)"
            });
          }
          if($(this).find(".btn-img").length) {
            gsap.to($(this).find(".btn-img"), 1.5, {
              x: 0,
              y: 0,
              ease: "elastic.out(1,0.3)"
            });
          }
        });
      });

      // Mouse move
      function moveMagnet(event) {

        let magnetButton = event.currentTarget;
        let bounding = magnetButton.getBoundingClientRect();
        let magnetsStrength = magnetButton.getAttribute("data-strength");
        let magnetsStrengthText = magnetButton.getAttribute("data-strength-text");

        gsap.to( magnetButton, 1.5, {
          x: ((( event.clientX - bounding.left)/magnetButton.offsetWidth) - 0.5) * magnetsStrength,
          y: ((( event.clientY - bounding.top)/magnetButton.offsetHeight) - 0.5) * magnetsStrength,
          rotate: "0.001deg",
          ease: "power4.out"
        });

        if($(this).find(".btn-text").length) {
          gsap.to( $(this).find(".btn-text"), 1.5, {
          x: ((( event.clientX - bounding.left)/magnetButton.offsetWidth) - 0.5) * magnetsStrengthText,
          y: ((( event.clientY - bounding.top)/magnetButton.offsetHeight) - 0.5) * magnetsStrengthText,
          rotate: "0.001deg",
          ease: "power4.out"
        });
        }
        if($(this).find(".btn-img").length) {
          gsap.to($(this).find(".btn-img"), 1.5, {
            x: (((event.clientX - bounding.left) / magnetButton.offsetWidth) - 0.5) * magnetsStrengthText,
            y: (((event.clientY - bounding.top) / magnetButton.offsetHeight) - 0.5) * magnetsStrengthText,
            rotate: "0.001deg",
            ease: "power4.out"
          });
        }
      }

    }

    // Mouse Enter
    $('.btn-click.magnetic').on('mouseenter', function() {
      if($(this).find(".btn-fill").length) {
        gsap.to($(this).find(".btn-fill"), .6, {
          startAt: {y: "76%"},
          y: "0%",
          ease: "power2.inOut"
        });
      }
      if($(this).find(".btn-text-inner.change").length) {
        gsap.to($(this).find(".btn-text-inner.change"), .3, {
          startAt: {color: "#ffffff"},
          color: "#1a1b1d",
          ease: "power2.in",
          overwrite: true
        });
      }
      //$(this.parentNode).removeClass('not-active');
    });

    // Mouse Leave
    $('.btn-click.magnetic').on('mouseleave', function() {
      if($(this).find(".btn-fill").length) {
        gsap.to($(this).find(".btn-fill"), .6, {
          y: "-76%",
          ease: "power2.inOut"
        });
      }

      if($(this).find(".btn-text-inner.change").length) {
        gsap.to($(this).find(".btn-text-inner.change"), .3, {
          startAt: {color: "#1a1b1d"},
          color: "#ffffff",
          ease: "power2.out",
          delay: .3
        });
      }
      //$(this.parentNode).removeClass('not-active');
    });
  }

  getSmoother = () => {
    return smoother;
  }

  initGlobalAnimations = () => {

    // content videos viewport
    let allVideoDivs = gsap.utils.toArray('.content_video');
    allVideoDivs.forEach((videoDiv) => {

      let videoElem = videoDiv.querySelector('video')
      //videoElem.play()
      videoElem.controls = false;

      ScrollTrigger.create({
        //scroller: document.querySelector('[data-scroll-container]'),
        trigger: videoElem,
        start: '0% 80%',
        end: '100% 20%',
        markers: false,
        onEnter: () => videoElem.play(),
        onEnterBack: () => videoElem.play(),
        onLeave: () => videoElem.pause(),
        onLeaveBack: () => videoElem.pause(),
      });

    });

    // p_breadbrumb
    const elementGroup = gsap.utils.toArray('.p_breadbrumb');
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 100%',
          end: 'top 50%',
          markers: false,
          scrub: 1
        },
        y: 50,
        alpha: 0
      });
        ScrollTrigger.refresh();
    });

    // p_parallax
    const copyGroup = gsap.utils.toArray('.p_parallax');
    copyGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          end: 'top 60%',
          markers: false,
          scrub: 0,
        },
        y: 40,
        scale: .9,
        alpha: 0
      });
    });

    // parallax images
    gsap.utils.toArray(".image-container").forEach(function(container) {
      let image = container.querySelector("img");

      // container
      gsap.from(container, {
        y: () => -(image.offsetHeight - container.offsetHeight) / 10,
        ease: "none",
        scrollTrigger: {
          trigger: container,
          scrub: true,
          pin: false,
          markers: false,
          invalidateOnRefresh: true
        },
      });

      gsap.to(image, {
        y: () => image.offsetHeight - container.offsetHeight,
        ease: "none",
        scrollTrigger: {
          trigger: container,
          scrub: true,
          pin: false,
          markers: false,
          invalidateOnRefresh: true
        },
      });
    });
  }

  initNaviAnimations = () => {

    // mobile check
    let mm = gsap.matchMedia();

    //return;

    // desktop
    mm.add("(min-width: 768px)", () => {

      // show/hide top navi
      gsap.fromTo('.top_nav-list',
        {
          autoAlpha: 1,
          duration: 2,
          y:0,
        },
        {
          autoAlpha:0,
          duration: 3,
          y: '10px',
          scrollTrigger: {
            trigger: ".top_nav",
            scrub: true,
            start: 'top top',
            end: '100 top',
            markers: false
          }
        })

      // show/hide burger
      gsap.fromTo('.burger_menu',
        {
          autoAlpha: 0,
          y: '-10px',
        },
        {
          autoAlpha:1,
          duration: 3,
          y: 0,
          scrollTrigger: {
            trigger: ".burger_menu",
            scrub: true,
            start: '200 10%',
            end: '200 0%',
            markers: false
          }
        })
    });

    // mobile
    mm.add("(max-width: 767px)", () => {
      gsap.set('.top_nav-list', {autoAlpha:0});
      gsap.set('.burger_menu', {autoAlpha:1});
    });
  }

  animateNavi = () => {

    //let hash = window.location.hash;
    //if(hash == 'fff') {
    let tl = gsap.timeline({});
    tl.set('.top_logo', {y: '-20px', alpha: 0, duration: 0 }, 0);
    tl.to('.top_logo', {y: 0, alpha: 1,  duration: .7, ease: "power1.out" }, .8);
    tl.set('.top-nav-link', {y: '-10px', alpha: 0, duration: 0 }, 0);
    tl.to('.top-nav-link', {y: 0, alpha: 1,  duration: .7, ease: "power1.out", stagger: .1 }, .8);
    tl.set('.burger_menu', {y: '-20px', alpha: 0, duration: 0 }, 0);
    tl.to('.burger_menu', {y: 0, alpha: 1,  duration: .7, ease: "power1.out" }, .8);
    //}
  }

  initHomeAnimations = () => {

    // parallax bg
    gsap.to('.header_background', {
      scrollTrigger: {
        trigger: '.header_background',
        start: 'top 0',
        end: 'bottom top',
        markers: false,
        scrub: true
      },
      y: 300,
      //opacity: .8,
      scale:1.2
    });
    // parallax bg
    gsap.to('.background_abdecker', {
      scrollTrigger: {
        trigger: '.background_abdecker',
        start: 'top top',
        end: 'bottom top',
        markers: false,
        scrub: true
      },
      opacity: .4,
    });

    // show page
    let pageRotation = 10;
    if(isMobile) { pageRotation = 4; }

    gsap.set( '.section', {
      rotate: pageRotation,
      ease: "expo.out",
      scale: 1.3,//.3,
      opacity: 1,
      y: '500px' //'20%'
    });

    gsap.to('.section', {
      rotate: 0,
      duration:  1.2,
      repeat: 0,
      ease: "expo.out",
      scale: 1,
      opacity: 1,
      y: 0
    });


    // animate header text
    let splitHeadline = new SplitText( ".header_headline", {type: "lines", linesClass: "split-line"});
    let splitCopy01 = new SplitText(".header_copy_01", {type: "lines", linesClass: "split-line"});
    $('.header_copy_01 .split-line').wrap('<div class="line-wrapper">');

    let tl = gsap.timeline({});
    tl.set(splitHeadline.lines, {top: '200px', alpha: 0, duration: 0 }, 0);
    tl.to(splitHeadline.lines, {top: 0,  duration: 1, ease: "power4.out", stagger: 0.3 }, .4);
    tl.to(splitHeadline.lines, {alpha: 1, duration: 1, ease: "power1.out", }, .4);

    tl.set(splitCopy01.lines, {top: '50px', alpha: 0, duration: 0 }, 0);
    tl.to(splitCopy01.lines, {top: 0,  duration: 1, ease: "power4.out", stagger: .1 }, .6);
    tl.to(splitCopy01.lines, {alpha: 1, duration: 1, ease: "power1.out", }, .6);

    tl.set('.header_scroll_button', {y: '50px', scale: .1, alpha: 0, duration: 0 }, 0);
    tl.to('.header_scroll_button', {y: 0, scale: 1,  duration: 1.2, ease: "back.out(1)", stagger: .1 }, .6);
    tl.to('.header_scroll_button', {alpha: 1, duration: .7, ease: "power1.out", }, 1);
  }

  initProfilAnimations = () => {
    updateHeadline(".profil_headline_trigger", ".profil_headline");
  }

  initServiceAnimation() {

    updateHeadline(".service_headline_trigger", ".service_headline");

    // service_holder
    const serviceHolder = gsap.utils.toArray('.service_holder');
    serviceHolder.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 100%',
          end: 'top 80%',
          markers: false,
          scrub: 1
        },
        y: 50,
        scale: .9,
        opacity: 0
      });
    });

    // service_spacer
    const serviceSpacer = gsap.utils.toArray('.service_spacer');
    serviceSpacer.forEach((element) => {
      gsap.fromTo(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 100%',
          end: 'top 80%',
          markers: false,
          scrub: 1
        },
        width: 1
      },
        {
          scrollTrigger: {
            trigger: element,
            start: 'top 100%',
            end: 'top 80%',
            markers: false,
            scrub: 1
          },
          width: '100%',
        });

    });
  }

  initWorkAnimation() {

    //updateWorkHeadline();
    updateHeadline(".work_headline_trigger", ".work_headline");

    // projects
    const copyGroup = gsap.utils.toArray('.work_project_holder');
    copyGroup.forEach((element) => {
      gsap.fromTo(element,
        {
          scrollTrigger: {
            trigger: element,
            start: 'top 120%',
            end: 'bottom 80%',
            markers: false,
            scrub: 1,
            invalidateOnRefresh: true
          },
          x: '40%',
          stagger:{
            from:"start", //try "center" and "edges"
            //each:0.2
          }
        },
        {
          scrollTrigger: {
            trigger: element,
            start: 'top 120%',
            end: 'bottom 80%',
            markers: false,
            scrub: 1,
            invalidateOnRefresh: true
          },
          x: '0%',
        });

    });
  }

  initWorkDetailAnimation = () => {

    // parallax images
    gsap.utils.toArray('.header_image').forEach(container => {
      const img = container.querySelector('img');
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          scrub: true,
          pin: false,
          start: 'top 100%',
          end: 'bottom 0%',
          markers: false,
        }
      });

      tl.fromTo(img,
        {
          scale: 1.0,
          yPercent: -10,
          ease: 'none'
        },
        {
          scale: 1.0,
          yPercent: 10,
          ease: 'none'
        });
    });

    // macbook
    gsap.from('.macbook_holder', {
      scrollTrigger: {
        trigger: '.macbook_holder',
        start: 'top 120%',
        end: 'bottom 60%',
        markers: false,
        scrub: 0
      },
      y: 40,
      scale: 1.4
    });

    // content images
    const copyGroup = gsap.utils.toArray('.content_image');
    copyGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 120%',
          end: 'top 40%',
          markers: false,
          scrub: 0
        },
        y: '100px',
        scale: .9
      });
    });

    // ipad_image
    if ($('.ipad_holder').length > 0) {
      gsap.fromTo('.ipad_holder',
        {
          scrollTrigger: {
            trigger: '.ipad_image',
            start: 'top 120%',
            end: 'bottom 20%',
            markers: false,
            scrub: true,
            invalidateOnRefresh: true
          },
          scale: .8,
          stagger: {
            from: "start", //try "center" and "edges"
            each: 0.2
          }
        },
        {
          scrollTrigger: {
            trigger: '.ipad_image',
            start: 'top 120%',
            end: 'bottom 10%',
            markers: false,
            scrub: true,
            invalidateOnRefresh: true
          },
          scale: 1.0,
        });
    }

    // background image
    if ($('.background_image').length > 0) {
      gsap.utils.toArray('.background_image').forEach(container => {
        const img = container.querySelector('img');
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: container,
            scrub: true,
            pin: false,
            start: 'top 100%',
            end: 'bottom 0%',
            markers: false,
          }
        });

        tl.fromTo(img,
          {
            yPercent: -20,
            ease: 'none'
          },
          {
            yPercent: 20,
            ease: 'none'
          });
      });
    }

    //  iphone
    if( $('.iphone_image_01').length > 0)
    {
      gsap.fromTo('.iphone_image_01',
        {
          scrollTrigger: {
            trigger: '.iphone_image_01',
            start: 'top 100%',
            end: 'bottom -20%',
            markers: false,
            scrub: true,
            invalidateOnRefresh: true
          },
          y: '20%',
          stagger: {
            from: "start", //try "center" and "edges"
            each: 0.2
          }
        },
        {
          scrollTrigger: {
            trigger: '.iphone_image_01',
            start: 'top 100%',
            end: 'bottom -20%',
            markers: false,
            scrub: true,
            invalidateOnRefresh: true
          },
          y: '-10%',
        });
    }
    if( $('.iphone_image_03').length > 0)
    {
      gsap.fromTo('.iphone_image_03',
        {
          scrollTrigger:
            {
              trigger: '.iphone_image_03',
              start: 'top 100%',
              end: 'bottom -20%',
              markers: false,
              scrub: true,
              invalidateOnRefresh: true
            },
          y: '-20%',
          stagger:
            {
              from: "start", //try "center" and "edges"
              each: 0.2
            }
        },
        {
          scrollTrigger: {
            trigger: '.iphone_image_03',
            start: 'top 100%',
            end: 'bottom -20%',
            markers: false,
            scrub: true,
            invalidateOnRefresh: true
          },
          y: '10%',
        });
    }
  }

  initWorkdetailsIntroAnimation = () => {

    // content
    gsap.set( '.intro_animation', {
      y: '100px',
      alpha: 0
    });
    gsap.to('.intro_animation', {
      duration:  2,
      alpha: 1,
      ease: "expo.out",
      opacity: 1,
      y: 0,
      stagger: 0.1,
      delay: .3
    });

    // show page
    gsap.set( '.page', {
      rotate: 10,
      ease: "expo.out",
      scale: 1.3,
      opacity: 1,
      //y: '10%',
      y: '20%'
    });
    gsap.to('.page', {
      rotate: 0,
      duration:  1.2,
      repeat: 0,
      ease: "expo.out",
      scale: 1,
      opacity: 1,
      y: 0,
      onComplete: function()
      {

      }
    });

  }

  initKontaktAnimation() {

    gsap.from('.kontakt_holder', {
      scrollTrigger: {
        trigger: '#kontakt',
        start: 'top 100%',
        end: 'bottom 100%',
        markers: false,
        scrub: 0
      },
      ease: "none",
      y: "-50%"
    });
  }

  initNextProjectAnimation = () => {

    gsap.from('.next_project_holder', {
      scrollTrigger: {
        trigger: '#next_project',
        start: 'top 100%',
        end: 'bottom 100%',
        markers: false,
        scrub: 0
      },
      ease: "none",
      y: "-50%"
    });

    //image
   /*
    gsap.utils.toArray(".next_project_image_holder").forEach(function(container) {
      let image = container.querySelector("img");

      const img = container.querySelector('img');
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          scrub: true,
          pin: false,
          //start: 'top 100%',
          //end: 'bottom 0%',
          start: 'center 110%',
          end: 'center 70%',
          markers: false,
        }
      });

      tl.fromTo(img,
        {
          scale: 1.0,
          y: 50,
          ease: 'none'
        },
        {
          scale: 1.0,
          y: (image.offsetHeight - container.offsetHeight),
          ease: 'none'
        });


    });
*/
  }

  onResize = () => {
    jQuery(window)
      .resize(function () {

        splitProfilHeadline.revert();
        splitServiceHeadline.revert();
        splitWorkHeadline.revert();

        updateHeadline(".profil_headline_trigger", ".profil_headline");
        updateHeadline(".service_headline_trigger", ".service_headline");
        updateHeadline(".work_headline_trigger", ".work_headline");

        ScrollTrigger.refresh();
      })
  };
}

export default CustomAnimation;
